import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Routes } from '../../config/Routes';
import AppbarMenu from './Navbar';
import Sidebar from './SidebarList';
import SidebarContent from './Sidebar';
import useStyles from './styles';
import reactLogger from 'utils/logger';
import { useTheme } from '@material-ui/core';
import UserDrawer from './UserDrawer';
import useHomePage from 'hooks/useHomePage';
import { useHostDetails } from 'redux/reducers/gl_host_provider/selectors';
import { Environment } from 'config';

interface IProps {
  visible: boolean;
}

export default function Appbar({ visible }: IProps) {
  reactLogger.renderPage('Appbar');

  if (visible) {
    return <DataDrawer />;
  } else {
    return <Routes />;
  }
}

function DataDrawer() {
  reactLogger.renderComponent('DataDrawer');

  const classes = useStyles({});
  const theme = useTheme();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <HomePageWallpaper />
      <AppbarMenu />
      <Sidebar />
      <SidebarContent />
      <UserDrawer />
    </div>
  );
}

const HomePageWallpaper = () => {
  const isHomepage = useHomePage();
  const [visible, setVisible] = React.useState(false);
  const hostDetails = useHostDetails();
  const hostSettings = hostDetails?.data?.settings;
  // Cause warning momery leak
  React.useLayoutEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 500);

    return () => {
      setVisible(false);
    };
  }, [setVisible]);

  return (
    <>
      {isHomepage && visible && (
        <div
          style={{
            backgroundImage: `url(${
              hostSettings?.['cellock.theme.backgroundImage'] !== ''
                ? `${Environment.API_BASE_URL}/${hostSettings?.['cellock.theme.backgroundImage']}`
                : require('assets/images/backgrounds/home-wallpaper.png')
                    .default
            })`,
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            zIndex: -1,
          }}
        />
      )}
    </>
  );
};
